import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../shared/hooks/useAuth';
import { useAccessToken, useUser } from '../shared/store/userStore';
import Navigation from './Navigation';

function ProtectedLayout() {
  const accessToken = useAccessToken();
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { getUserInfo } = useAuth();

  // AdminLayout 경로인지 확인
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!accessToken) {
      navigate('/login', { replace: true });
      return;
    }

    // 토큰이 있고, 유저 정보가 없으면 항상 getUserInfo 호출 (최신 권한/유저 정보 fetch)
    if (accessToken && !user) {
      getUserInfo();
    }
  }, [accessToken, user, getUserInfo, navigate]);

  if (!accessToken) {
    return null; // 리다이렉트 처리 중에는 아무것도 렌더링하지 않음
  }
  if (!user) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        사용자 정보를 불러오는 중...
      </div>
    );
  }

  // Admin 경로는 Navigation 없이 전체 화면 사용
  if (isAdminRoute) {
    return (
      <div className='min-h-screen'>
        <Navigation />
        <Outlet />
      </div>
    );
  }

  // 일반 경로는 스크롤 가능한 레이아웃 사용
  return (
    <div className='h-screen flex flex-col overflow-hidden'>
      <Navigation />
      <div className='flex-1 overflow-y-auto bg-gray-50'>
        <Outlet />
      </div>
    </div>
  );
}

export default ProtectedLayout;
